import {
	HelmetDexteel,
	useHasPermission,
	useUserContext,
} from "@dexteel/mesf-core";
import { Alert, LinearProgress } from "@mui/material";
import { OperationsTimeline } from "./components/OperationsTimeline";
import { TIMELINE_PERMISSION } from "./models";

export function OperationsTimelinePage() {
	const hasPermission = useHasPermission();
	const { isLoading } = useUserContext();
	return (
		<>
			<HelmetDexteel title="Mill Operations Timeline" />
			{isLoading ? (
				<LinearProgress aria-label="Loading permissions" />
			) : hasPermission(TIMELINE_PERMISSION) ? (
				<OperationsTimeline />
			) : (
				<Alert severity="warning" sx={{ m: 2 }}>
					You do not have permission to view the Mill Operations Timeline.
				</Alert>
			)}
		</>
	);
}
